const foods = [
  {
    name: '楼下汉堡',
    emoji: '🍔',
  },
  {
    name: '麦当劳',
    emoji: '🍟'
  },
  {
    name: 'KFC',
    emoji: '🍗'
  },
  {
    name: '外卖馄饨',
    emoji: '🥟',
  },
  {
    name: '吉野家',
    emoji: '🍛'
  },
  {
    name: 'SUBWAY',
    emoji: '🥪'
  },
  {
    name: '便宜盒饭',
    emoji: '🍱'
  },
  {
    name: '必胜客大饼',
    emoji: '🍕'
  }
]

const getFoods = () => {
  return foods;
}

export default getFoods;
